import React from 'react';

import type { CommonFleetRuleProps, FleetRuleBodyTranslations } from '../fleet-rule-utils';
import { Condition } from '../../rule/rule-utils';

import { FleetRuleLeftSide } from './fleet-rule-left-side';
import { FleetRuleRightSide } from './fleet-rule-right-side';
import {
	FleetRuleLeftSideHandlers,
	FleetRuleLeftSideOptions,
	FleetRuleRightSideHandlers,
	FleetRuleRightSideOptions,
	FeatureFlags
} from '../fleet-rule-utils';

import styles from '../fleet-rule.module.scss';
import '../fleet-rule.scss';

interface FleetRuleBodyProps extends CommonFleetRuleProps {
	translations: FleetRuleBodyTranslations;
	fleetRuleRightSideHandlers: FleetRuleRightSideHandlers;
	fleetRuleRightSideOptions: FleetRuleRightSideOptions;
	fleetRuleLeftSideHandlers: FleetRuleLeftSideHandlers;
	fleetRuleLeftSideOptions: FleetRuleLeftSideOptions;
	handleChange: (c: Condition, value: unknown) => void;
	removeCondition: (c: Condition) => void;
	addCondition(key: string): void;
	featureFlags?: FeatureFlags;
}

export const FleetRuleBody = ({
	translations,
	disabled = false,
	fleetRuleRightSideOptions,
	fleetRuleRightSideHandlers,
	fleetRuleLeftSideHandlers,
	fleetRuleLeftSideOptions,
	removeCondition,
	handleChange,
	addCondition,
	featureFlags
}: FleetRuleBodyProps) => (
	<>
		<div data-test-id="fleet-router-rule-body" className={styles['main-container']}>
			<div data-test-id="fleet-router-rule-body-left-side" className="fleet-rule-component-left-side">
				<FleetRuleLeftSide
					overallChecked={fleetRuleLeftSideOptions.leftCheckboxValue}
					translations={translations.fleetRuleLeftSide}
					disabled={disabled}
					fleetRuleLeftSideOptions={fleetRuleLeftSideOptions}
					handleChange={handleChange}
					removeCondition={removeCondition}
					addCondition={addCondition}
					handleMultiselectChange={fleetRuleLeftSideHandlers.handleMultiselectChange}
					handleCheckedOverall={fleetRuleLeftSideHandlers.onChangeCheckbox}
				/>
			</div>
			<div data-test-id="fleet-router-rule-body-right-side" className={styles['right-side']}>
				<FleetRuleRightSide
					disabled={disabled}
					translations={translations.fleetRuleRightSide}
					fleetRuleRightSideOptions={fleetRuleRightSideOptions}
					fleetRuleRightSideHandlers={fleetRuleRightSideHandlers}
					featureFlags={featureFlags}
				/>
			</div>
		</div>
	</>
);
